const splitUrlParams = (url) => {
  const searchIndex = url.indexOf('?')

  if (searchIndex < 0) {
    return { url, params: {} }
  }

  const urlBase = url.slice(0, searchIndex)
  const params = url
    .slice(searchIndex + 1)
    .split('&')
    .reduce((acc, hash) => {
      const [key, val] = hash.split('=')
      return {
        ...acc,
        [key]: decodeURIComponent(val),
      }
    }, {})

  return {
    url: urlBase,
    params,
  }
}

export default splitUrlParams
